// Selector de período/semana WYN para Liquidaciones > Clientes/Choferes
// (ver auditoría Fase 1.5 — "Liquidaciones UX"): reutiliza exactamente
// GET /v1/liquidaciones/periodos, el mismo endpoint que ya usa
// LiquidacionesHistorial.tsx — ningún mecanismo nuevo. "Semana actual" es
// el valor vacío (sin ?period= en la URL, igual que Dashboard/Historial);
// cada semana cerrada es su period_key real. No infiere/calcula fechas acá
// — el backend sigue siendo la única fuente de verdad de qué semanas
// existen y cuál es la actual.
import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { authFetch } from "../../lib/authFetch";

type PeriodRow = { id: number; period_key: string; starts_on: string; ends_on: string; status: "OPEN" | "CLOSED" };
type PeriodosResponse = { ok: boolean; current: PeriodRow; closed: PeriodRow[] };

const selectStyle: React.CSSProperties = {
  minHeight: "48px",
  padding: "0 14px",
  borderRadius: "14px",
  border: "1px solid var(--border)",
  background: "var(--surface-alt, transparent)",
  color: "var(--text-primary)",
  fontSize: "14px",
};

// Tolerante a "YYYY-MM-DD" — starts_on/ends_on ya vienen como fecha ::text
// (mismo criterio que LiquidacionesHistorial.tsx).
function formatFecha(raw: string | null): string {
  if (!raw) return "—";
  const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
  return raw;
}

export default function PeriodSelector({ periodKey, onChange }: { periodKey: string | null; onChange: (periodKey: string | null) => void }) {
  const { token } = useAuth();
  const [data, setData] = useState<PeriodosResponse | null>(null);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    authFetch("/v1/liquidaciones/periodos", { token })
      .then(async (res) => {
        const payload = await res.json().catch(() => ({}));
        if (!cancelled && res.ok && payload?.ok !== false) setData(payload);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (!data) return null;

  return (
    <select
      style={selectStyle}
      value={periodKey || ""}
      onChange={(e) => onChange(e.target.value || null)}
      aria-label="Semana WYN"
    >
      <option value="">Semana actual ({formatFecha(data.current.starts_on)} → {formatFecha(data.current.ends_on)})</option>
      {data.closed.length > 0 && (
        <optgroup label="Semanas anteriores (cerradas)">
          {data.closed.map((p) => (
            <option key={p.id} value={p.period_key}>
              {formatFecha(p.starts_on)} → {formatFecha(p.ends_on)}
            </option>
          ))}
        </optgroup>
      )}
    </select>
  );
}
